import * as Vue from 'vue';
import App from "@/App.vue";
import router from "@/router";
import { App as CapacitorApp } from '@capacitor/app'
import vuetify from "@/plugins/vuetify";
import chartJSPluginZoom from "chartjs-plugin-zoom";
import store from "@/store/index.js";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueDraggableResizable from "vue3-draggable-resizable";
import { getCustomBackHandler,useDefaultBackHandler } from './backButtonManager'
// To Avoid "Failed to resolve component" warning
import UserPopup from './components/Avatar/UserPopup.vue';
import FrontDeskForm from './components/AdminSettings/FrontDeskForm.vue';
import MessagePopup from './components/Messenger/MessagePopup.vue'
import Message from './components/Messenger/Message.vue'
import DefaultDisplay from './components/CallBar/DefaultDisplay.vue';
// import the vue virtual scroller
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

// optionally import default styles
import "vue3-draggable-resizable/dist/Vue3DraggableResizable.css";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

import { SafeArea } from 'capacitor-plugin-safe-area';

// add dayjs as a global object
import dayjs from './plugins/day';
// add the plivo browser sdk object as a global object
import plivoBrowserSdk from "@/plugins/plivo";
// try logging in to plivo (useful on page refresh)
store.dispatch("logInPlivoSDK");
// if (process.env.NODE_ENV === "production") {
//         console.log = function () {};
// }
const app = Vue.createApp(App)
app.config.globalProperties.plivoBrowserSdk = plivoBrowserSdk;
app.config.globalProperties.dayjs = dayjs;

app.use(router);
app.use(store);
app.use(vuetify);
app.use(chartJSPluginZoom);
app.use(VueVirtualScroller);

//------------------------------------------------------------------------
app.component("vue3-draggable-resizable", VueDraggableResizable);

// We Reuse these components in multiple components
app.component("UserPopup",UserPopup);
app.component("FrontDeskForm",FrontDeskForm);
app.component("MessagePopup",MessagePopup);
app.component("Message",Message)
app.component("DefaultDisplay",DefaultDisplay);
app.component("QuillEditor", QuillEditor);

// Register a global custom directive called v-focus
app.directive("focus", {
  mounted: (el) => el.focus()
});

CapacitorApp.addListener('backButton', () => {
const handler = getCustomBackHandler()
console.log("handler set is"+handler);
if(handler){
	handler();
}else{
    useDefaultBackHandler(router);
}
})

app.mount("#app");


(function(w,d,s,r,k,h,m){
        if(w.performance && w.performance.timing && w.performance.navigation) {
                w[r] = w[r] || function(){(w[r].q = w[r].q || []).push(arguments)};
                h=d.createElement('script');h.async=true;h.setAttribute('src',s+k);
                d.getElementsByTagName('head')[0].appendChild(h);
                (m = window.onerror),(window.onerror = function (b, c, d, f, g) {
                m && m(b, c, d, f, g),g || (g = new Error(b)),(w[r].q = w[r].q || []).push(["captureException",g]);})
        }
})(window,document,'//static.site24x7rum.com/beacon/site24x7rum-min.js?appKey=','s247r','61696df0fbbd8847ac675d202273ae75');

document.addEventListener('DOMContentLoaded', async () => {
        // Apply safe area variables once app starts
        SafeArea.getSafeAreaInsets().then(({insets}) => {
                console.log("DBG:: Initial insets: ", insets);
                document.documentElement.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
                document.documentElement.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
                document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
                document.documentElement.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
        });
        
        // Optional: listen for changes (like rotation, gesture nav)
        SafeArea.addListener('safeAreaChanged', ({ insets }) => {
                console.log("DBG:: Updated insets: ", insets);
                document.documentElement.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
                document.documentElement.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
                document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
                document.documentElement.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
        });
});